import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountTransferCallbackSuccessPage} from 'features/deposit/transfer/DepositAccountTransferCallbackSuccessPage';

export const Route = createFileRoute(
  '/_protected/transfer/callback/success/$fromAccountId/$toAccountId/$amount',
)({
  component: DepositAccountTransferCallbackSuccessPage,
});
